import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(landing)/come-funziona-il-sistema-di-prenotazione/page.client.tsx");
